import { memo, Suspense } from 'react';
import { lazyRetry } from '@utils/lazyRetry';

const QuickPanel = lazyRetry(() => import('@/components/theme-layouts/components/quickPanel/QuickPanel'));

/**
 * The right side layout 2.
 */
function RightSideLayout2() {
  return (
    <Suspense>
      <QuickPanel />
    </Suspense>
  );
}

export default memo(RightSideLayout2);
